import React, { useState, useEffect } from 'react';

import '../assets/css/Cogen.css';
import logoRecruiter from '../assets/images/dashboard/logo-recruiter.png';
import logoMember from '../assets/images/dashboard/logo-member.svg';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import {
	Dropdown,
	Modal,
	Button,
	Container,
	Row,
	Col,
	// Badge,
} from 'react-bootstrap';
import { BellIcon } from '@primer/octicons-react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { ReqGet } from '../config/Requests';
import prof from '../assets/images/prof.svg';
import { majorVersion, minorVersion } from '../helper/version';
import { Badge, IconButton } from '@mui/material';
import { Box } from '@mui/system';

const year = new Date().getFullYear();
const preference = {
	recruiter: {
		logo: logoRecruiter,
		headCss: 'header header-recruiter content-100',
		name: 'user name-recruiter',
	},
	member: {
		logo: logoMember,
		headCss: 'header header-member content-100',
		name: 'user name-member',
	},
	client: {
		logo: logoMember,
		headCss: 'header header-member content-100',
		name: 'user name-member',
	},
};

export const Footer = () => (
	<div className='footer'>
		© {year} COGEN. All Rights Reserved |{' '}
		<Link to='/terms-of-services'> Terms of services </Link> |
		<Link to='/privacy-policy'> Privacy Policy</Link>| &nbsp;
		<b style={{ color: 'hsl(212deg 75% 51%)', fontSize: '12px' }}>
			v{majorVersion + '.' + minorVersion}
		</b>
	</div>
);

export const Header = user => {
	const isLogin = localStorage.getItem('isLogin');
	const userType = isLogin ? localStorage.getItem('userType') : 'public';
	const headerPreference = preference[user?.type] || preference.client;
	const { logo, headCss, name } = headerPreference;

	const [show, setShow] = useState(false);
	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);

	const [notificationCount, setNotificationCount] = useState([]);

	window?.OneSignal?.push(function () {
		window.OneSignal.on('notificationDisplay', function (event) {
			ReqGet('notifications/count')
				.then(res => {
					setNotificationCount(res.data);
				})
				.catch(err => {
					console.log(err.response);
				});
			console.warn('OneSignal notification displayed:', event);
		});
	});

	const profileString = localStorage.getItem('cogen_user_profile');
	let profile = null;
	if (profileString) {
		try {
			profile = JSON.parse(profileString);
		} catch (error) {
			console.error('Unable to read the stored user profile.', error);
		}
	}
	const profileUser = profile?.user;
	const firstName = profileUser?.first_name || '';

	useEffect(() => {
		ReqGet('notifications/count')
			.then(res => {
				setNotificationCount(res.data);
			})
			.catch(err => {
				console.log(err.response);
			});
	}, []);

	const logout = () => {
		const tokenId = localStorage.getItem('tokenId');
		axios.delete(
			'http://ec2-3-13-248-4.us-east-2.compute.amazonaws.com/dev/logout/' +
				tokenId
		);
		localStorage.clear();
		localStorage.setItem('userType', 'public');
		window.location.href = `/`;
	};
	const navigate = useNavigate();

	return (
		<Container fluid className={headCss}>
			<Row fluid='md' md='auto'>
				<Col centered='true' md={{ span: 2, offset: 1 }} className='mt-2'>
					<img
						onClick={() => {
							navigate('/');
						}}
						src={logo}
						className='header-logo'
						alt='logo'
					/>
				</Col>
				<Col md={{ span: 2, offset: 6 }} className='d-flex flex-row-reverse'>
					<Dropdown className={`ml-1 mt-3 ${name}`}>
						<Dropdown.Toggle
							variant='white'
							className={
								userType === 'member' || userType === 'client'
									? 'name btn-menu-light text-white'
									: 'name btn-menu-light text-black'
							}
							id='dropdown-basic'
						>
							{firstName}
						</Dropdown.Toggle>
						{userType === 'recruiter' ? (
							<Dropdown.Menu>
								<Dropdown.Item
									className='dash-btn'
									onClick={() => navigate('/profile')}
								>
									Profile
								</Dropdown.Item>
								<Dropdown.Item
									className='dash-btn'
									onClick={() => navigate('/invite-member')}
								>
									Invite Member
								</Dropdown.Item>
								<Dropdown.Item
									className='dash-btn'
									onClick={() => navigate('/terms-of-services')}
								>
									Terms of Services
								</Dropdown.Item>
								<Dropdown.Item
									className='dash-btn'
									onClick={() => navigate('/privacy-policy')}
								>
									Privacy Policy
								</Dropdown.Item>
								<Dropdown.Item
									className='dash-btn'
									onClick={() => navigate('/subscribe')}
								>
									Subscription
								</Dropdown.Item>
								<Dropdown.Item className='dash-btn' onClick={handleShow}>
									Logout
								</Dropdown.Item>
							</Dropdown.Menu>
						) : (
							<Dropdown.Menu>
								<Dropdown.Item
									className='dash-btn'
									onClick={() => navigate('/profile')}
								>
									Profile
								</Dropdown.Item>
								<Dropdown.Item
									className='dash-btn'
									onClick={() => navigate('/')}
								>
									Dashboard
								</Dropdown.Item>
								<Dropdown.Item
									className='dash-btn'
									onClick={() => navigate('/terms-of-services')}
								>
									Terms of Services
								</Dropdown.Item>
								<Dropdown.Item
									className='dash-btn'
									onClick={() => navigate('/privacy-policy')}
								>
									Privacy Policy
								</Dropdown.Item>
								<Dropdown.Item
									className='dash-btn'
									onClick={() => navigate('/subscribe')}
								>
									Subscription
								</Dropdown.Item>
								<Dropdown.Item className='dash-btn' onClick={handleShow}>
									Logout
								</Dropdown.Item>
							</Dropdown.Menu>
						)}
					</Dropdown>
					<div
						style={{
							display: 'inline-block',
							width: '70px',
							height: '36px',
							padding: '1rem',
							marginTop: '-3%',
						}}
					>
						<img
							style={{
								padding: '1px',
								width: '45px',
								height: '45px',
								marginTop: '0%',
								borderRadius: '100%',
								objectFit: 'cover',
							}}
							className='profile'
								src={
									!profileUser?.profile_image
										? prof
										: profileUser.profile_image +
									  '?img=' +
									  Math.random().toString(36).substring(7)
							}
							alt='profile'
						/>
					</div>

					<IconButton
						sx={{ mt: 2, mr: 1 }}
						onClick={() => navigate('/notifications/0')}
					>
						<Badge
							badgeContent={
								notificationCount.unread > 0 ? notificationCount.unread : null
							}
							color='warning'
						>
							<NotificationsNoneIcon />
						</Badge>
					</IconButton>

					<Modal size='sm' show={show} onHide={handleClose}>
						<Modal.Header className='no-border text-center'>
							<Modal.Title className='modal-title w-100 font-weight-bolder'>
								Logout
							</Modal.Title>
						</Modal.Header>
						<Modal.Body className='text-center'>
							Are you sure you want to logout?
						</Modal.Body>
						<Modal.Footer className='no-border'>
							<Button
								className='w-100  fw-bold btn-logout'
								variant='danger'
								onClick={() => logout()}
							>
								LOGOUT
							</Button>
							<Button
								className='w-100 fw-bold btn-logout'
								variant='light'
								onClick={handleClose}
							>
								CANCEL
							</Button>
						</Modal.Footer>
					</Modal>
				</Col>
			</Row>
		</Container>
	);
};
